<div
  class="
  border-b-2 border-lighterText py-4
  lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300"
>
  <div class="lg:text-lg font-semibold text-black">Erweitertes Kundenprofil</div>

  <div class="flex flex-col">
    <div class="flex gap-4">
      <span class="text-lightText text-xs lg:text-sm">
        {{ clampedText }}

        @if (descriptionText.length > 150) {
          <button
            class="text-lexusBlue hover:underline inline"
            (click)="toggleExpand()"
          >
          {{ textExpanded ? '[Weniger anzeigen]' : '[Weiterlesen]' }}
        </button>
        }
      </span>

      <div class="flex items-center lg:items-start gap-2">
        <app-checkbox-icon
          [imageClass]="getProfilingIcon('unchecked')"
          (click)="change(ConsentStatus.WITHDRAWN)"
          class="cursor-pointer"
        />
        <app-checkbox-icon
          [imageClass]="getProfilingIcon('checked')"
          (click)="change(ConsentStatus.CONFIRMED)"
          class="cursor-pointer"
        />
      </div>
    </div>
  </div>
</div>
